import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { debounce } from "lodash";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import KisList from "@/components/KIS/KisList/KisList.vue";
import KisFacilityEditDialog from "@/components/KIS/KisFacilityEditDialog/KisFacilityEditDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = { name: "", description: "", address: {}, active: true };

export default {
  name: "KisFacilityList",
  components: {
    KisFacilityEditDialog,
    KisList,
    TreeViewSelection,
    ValidationDialog
  },
  data: () => ({
    loading: false,
    editedItem: {},
    editDialog: false,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktiv", value: "active" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.loading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getFacilities", this.filter);
    await this.$store.dispatch("getDepartments");
    await this.$store.dispatch("getAllUsers");

    this.loading = false;
  },
  methods: {
    editItem(item) {
      this.editDialog = true;
      this.editedItem = cloneDeep(item);
    },
    addNewFacility() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = true;
    },
    copyItem(item) {
      this.editedItem = cloneDeep(item);
      delete this.editedItem?._id;
      this.editDialog = true;
    },
    closeDialog() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = false;
    },
    async getFacilities(filter) {
      await this.$store.dispatch("getFacilities", filter);
    },
    async updateFacility(facility) {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.put(
          `${env.kis_api_client_url}facility/${facility._id}`,
          facility,
          {
            params: {
              principal_id: facility.principal_id
            },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.setFacility(response.data);
          await this.$store.dispatch("getFacilities", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async deleteFacility(facility) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie diese Person wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = getTokenHeader();
          if (!this.editedItem.principal_id)
            this.editedItem.principal_id = this.currentPrincipal;
          const response = await axios.delete(
            `${env.kis_api_client_url}facility/${facility._id}`,
            {
              params: {
                principal_id: facility.principal_id
              },
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            await this.$store.dispatch("getFacilities", this.filter);
          } else {
            console.error(response);
            await this.$store.dispatch(
              "createError",
              "Es ist ein Fehler aufgetreten!"
            );
          }
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    setFacility(item) {
      this.editedItem = item;
    },
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getFacilities", this.filter);
    }, 500)
  },
  computed: {
    departments() {
      return this.$store.state.departments.map(
        department => (department = { title: department.name, ...department })
      );
    },
    facilities() {
      return this.$store.state.facilities;
    },
    facilityCount() {
      return this.$store.state.facilityCount;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
